import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import {Button, Form, Row, Col, Label, FormGroup, CustomInput} from 'reactstrap';
import {Form as FinalForm, Field} from 'react-final-form';
import {NotificationManager} from "../components/common/react-notifications";
import ModalManager from '../components/modal/ModalManager';
import {application, baseTokenSymbol} from "../constants/configs";
import {Range, getTrackBackground} from "react-range";
import LoaderButton from '../components/LoaderButton';
import TextField from "../components/TextField";
import Api from "../services/Api";
import {store} from "../AppRenderer";
import {find} from "lodash";

class InviteCodeForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      maxPlanableReferral: props.maxPlanableReferral,
    };
  }

  componentDidMount() {
    this.fetchActiveMaxReferral();
  }

  fetchActiveMaxReferral = async () => {
    const {userId} = this.props;
    try {
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/bonusPolicies',
        null,
        {
          params: {
            user: userId,
            effectObject: "MAX_REFERRAL",
            status: "ACTIVATED"
          }
      });
      if (data.rows[0]) {
        const {effectFunction} = data.rows[0];
        const limit = effectFunction.params.limit;
        this.setState({
          maxPlanableReferral: limit,
        });
      }
    } catch (e) {}
  };

  onCreate = async values => {
    const {maxPlanableReferral} = this.state;
    const {t, afterSubmit, userId} = this.props;
    try {
      await Api.invoke('POST', '/admin-ui/user-referrals', {
        ...values,
        userId,
        self: Number(values.self),
        user: maxPlanableReferral - Number(values.self),
      });
      setTimeout(afterSubmit, 1000);
      NotificationManager.success(t('Invite code created successfully'), t('Successful Operation'));
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  onUpdate = async values => {
    const {maxPlanableReferral} = this.state;
    const {t, referral, afterSubmit, userId} = this.props;
    try {
      await Api.invoke('PATCH', '/admin-ui/user-referrals', {
        ...values,
        userId,
        self: Number(values.self),
        user: maxPlanableReferral - Number(values.self),
        referCode: referral.referCode,
      });
      setTimeout(afterSubmit, 1000);
      NotificationManager.success(t('Referral updated successfully'), t('Successful Operation'));
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  getTokenLocaleName = symbol => {
    const {general} = store.getState();
    return find(general.tokens, item => item.symbol === symbol).localeName;
  };

  render() {
    const {t, referral} = this.props;
    const {maxPlanableReferral} = this.state;
    return(
      <FinalForm
        initialValues={{
          name: referral ? referral.name : undefined,
          user: referral ? Number(referral.user) : 0,
          self: referral ? Number(referral.self) : maxPlanableReferral,
          token: referral ? referral.token : baseTokenSymbol,
        }}
        onSubmit={referral ? this.onUpdate : this.onCreate}
        subscription={{submitting: true, pristine: true, hasValidationErrors: true, values: true}}
        render={({handleSubmit, submitting, pristine, hasValidationErrors, values}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className='mb-4'>
                <Row className='mb-2'>
                  <Col>
                    <TextField
                      item={{
                        name: 'name',
                        i18n: t('Plan Name'),
                        required: true,
                      }}
                    />
                  </Col>
                </Row>
                {application.platformName === 'exnovin' &&
                  <Row className='mb-2'>
                    <Col>
                      <Field name="token">
                        {({input}) => (
                          <div>
                            <Label>
                              {t('Get paid with')}
                              <span className="required">*</span>
                            </Label>
                            <FormGroup className='d-flex flex-row align-items-center'>
                              <CustomInput
                                id="smtp"
                                type="radio"
                                name="customRadio"
                                checked={input.value === baseTokenSymbol}
                                label={this.getTokenLocaleName(baseTokenSymbol)}
                                onChange={() => {input.onChange(baseTokenSymbol);}}
                              />
                              <CustomInput
                                type="radio"
                                id="mailgun"
                                className='mx-4'
                                name="customRadio"
                                checked={input.value === 'USDT'}
                                label={this.getTokenLocaleName('USDT')}
                                onChange={() => {input.onChange('USDT');}}
                              />
                            </FormGroup>
                          </div>
                        )}
                      </Field>
                    </Col>
                  </Row>
                }
                <Row>
                  <Col>
                    <Field name="self">
                      {({input}) => (
                        <div>
                          <span>
                            {t('Specify user share of friends trades fee, the rest will be friends share. (The total share of user and user friends should be {{max}}%)', {
                              max: maxPlanableReferral,
                            })}
                          </span>
                          <div dir='ltr' className='d-flex align-items-center justify-content-center m-2'>
                            <Range
                              step={1}
                              min={0}
                              values={[input.value]}
                              max={maxPlanableReferral}
                              onChange={(selected) => {input.onChange(selected[0]);}}
                              renderTrack={({ props, children }) => (
                                <div
                                  onMouseDown={props.onMouseDown}
                                  onTouchStart={props.onTouchStart}
                                  style={{
                                    ...props.style,
                                    height: "36px",
                                    display: "flex",
                                    width: "100%"
                                  }}
                                >
                                  <div
                                    ref={props.ref}
                                    style={{
                                      height: "5px",
                                      width: "100%",
                                      borderRadius: "4px",
                                      background: getTrackBackground({
                                        values: [input.value],
                                        colors: ["#548BF4", "#ccc"],
                                        min: 0,
                                        max: maxPlanableReferral
                                      }),
                                      alignSelf: "center"
                                    }}
                                  >
                                    {children}
                                  </div>
                                </div>
                              )}
                              renderThumb={({ props, isDragged }) => (
                                <div
                                  {...props}
                                  style={{
                                    ...props.style,
                                    height: "42px",
                                    width: "42px",
                                    borderRadius: "4px",
                                    backgroundColor: "#F1F1F1",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxShadow: "0px 2px 6px #AAA"
                                  }}
                                >
                                  <div
                                    style={{
                                      height: "16px",
                                      width: "5px",
                                      backgroundColor: isDragged ? "#548BF4" : "#CCC"
                                    }}
                                  />
                                </div>
                              )}
                            />
                            <output id="output" className='font-weight-semibold text-large mr-4' style={{width: 50}}>
                              {`${Number(input.value)}%`}
                            </output>
                          </div>
                        </div>
                      )}
                    </Field>
                  </Col>
                </Row>
              </div>
              <Row className='my-4 justify-content-around'>
                <Col>
                  <div className='text-center text-muted mb-2'>{t('User Share')}</div>
                  <div className='text-primary text-large font-weight-semibold text-center'>
                    {`${Number(values.self)}%`}
                  </div>
                </Col>
                <Col>
                  <div className='text-center text-muted mb-2'>{t('Friends Share')}</div>
                  <div className='text-primary text-large font-weight-semibold text-center'>
                    {`${maxPlanableReferral - Number(values.self)}%`}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className='d-flex flex-row justify-content-end pt-2'>
                  <LoaderButton
                    type="submit"
                    color="success"
                    loading={submitting}
                    onClick={handleSubmit}
                    disabled={pristine || hasValidationErrors || submitting}>
                    {referral ? t('Update') : t('Activate')}
                  </LoaderButton>
                  <Button
                    color="light"
                    className='mx-2'
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(InviteCodeForm);
